/**
 * Build-time site configuration.
 *
 * This is a static brochure — there is no runtime config fetch and no
 * niche-api call in the request path (constitution VIII / IV). The single
 * per-env axis is the business-portal origin the sign-up CTA hands off to:
 * per notes/domains-and-subdomains.md the business portal lives at
 * `app.<niche.domain>` and varies per environment —
 *
 *   dev → https://app.dev.fw.duvi.uk
 *   stg → https://app.stg.fw.duvi.uk
 *   prd → https://app.fw.duvi.uk (Fishwalkers prd is deprovisioned — dev/stg only)
 *
 * `VITE_BUSINESS_PORTAL_URL` is injected at build/deploy time (same pattern
 * as VITE_NICHE_* in duvi-niche-admin-portal/src/config.ts) so this repo
 * never hard-codes an environment; the dev URL below is only the local-dev
 * fallback when the var is unset.
 *
 * `businessRegisterPath` targets the self-service registration screen that
 * @duvi-agency/auth ships in duvi-niche-business-portal (epic 006 story 12,
 * not yet built at the time this brochure was written). "/register" is this
 * repo's documented assumption for that route — it is a single named
 * constant precisely so it is a one-line change if story 12 lands a
 * different path.
 */

const DEV_BUSINESS_PORTAL_URL = "https://app.dev.fw.duvi.uk";

export const businessRegisterPath = "/register";

export const config = {
  businessPortalUrl:
    (import.meta.env.VITE_BUSINESS_PORTAL_URL as string | undefined) ??
    DEV_BUSINESS_PORTAL_URL,
} as const;

/**
 * Builds the sign-up CTA target: the business registration screen on the
 * business portal, optionally pre-selecting a tier (pricing screen CTAs pass
 * their tier name, matching the bespoke Claude Design export's per-tier
 * "Sign up with {Tier}" CTAs).
 */
export function duviNicheSiteBuildRegisterUrl(tier?: string): string {
  const url = new URL(businessRegisterPath, config.businessPortalUrl);
  if (tier) url.searchParams.set("tier", tier);
  return url.toString();
}
